"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LayoutStyles_1 = require("../../../style/LayoutStyles");
var StyleFunctions_1 = require("../../../style/StyleFunctions");
var CellStyles_1 = require("./CellStyles");
var PlaceholderTextCell_1 = require("./PlaceholderTextCell");
var textCellClass = StyleFunctions_1.cssClass('textCell', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle);
var disabledTextCellClass = StyleFunctions_1.cssClass('textCell', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle, CellStyles_1.cellDisabledStyle);
function TextCellFormatter(props) {
    if (props.text) {
        return (React.createElement("div", { className: props.disabled ? disabledTextCellClass : textCellClass, title: props.text }, props.text));
    }
    else if (props.placeholder) {
        return React.createElement(PlaceholderTextCell_1.PlaceholderTextCell, { placeholderText: props.placeholder });
    }
    else {
        return React.createElement("div", { className: props.disabled ? disabledTextCellClass : textCellClass }); // so empty columns select row in connect-to grids
    }
}
exports.TextCellFormatter = TextCellFormatter;
function createTextCellFormatter(getTextFromRowData, placeholder, getDisabledFromRowData) {
    return function (props) { return (React.createElement(TextCellFormatter, { text: getTextFromRowData(props.row.data), placeholder: placeholder, disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false })); };
}
exports.createTextCellFormatter = createTextCellFormatter;
//# sourceMappingURL=TextCellFormatter.js.map